module.exports = __webpack_public_path__ + "static/img/2020123019370372.d9384ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2020123019370372.jpg
// module id = L3jm
// module chunks = 14